module.exports = __webpack_public_path__ + "e20895c514eaf916f4cfc3afa6747349.png";


//////////////////
// WEBPACK FOOTER
// ./pages/news/12/tasteline.png
// module id = 238
// module chunks = 0